export const maxSmallPhoneWidth = 375;
export const maxPhoneWidth = 549;
export const maxTabletWidth = 1080;
export const minDesktopWidth = 1081;
export const minTabletWidth = 550;
export const maxLandscapePhoneHeight = 600;
export const maxLandscapePhoneWidth = 1000;
